import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { userInfoKeys } from './user-info-keys';

import type { UserInfo } from '../model';

export const getUserInfo = async (): Promise<UserInfo> => {
  const response = await makeRequest<ResponseSuccess<UserInfo>>({
    url: `${config.apiHost}/auth/api/v1/merchant_authorizer/users/userinfo`,
    credentials: 'include',
    payload: {},
  });
  return response.payload;
};

export const useUserInfo = (
  options?: Omit<UseQueryOptions<UserInfo>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    ...options,
    queryKey: userInfoKeys.all(),
    queryFn: getUserInfo,
    gcTime: 0,
  });
};
